
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitment-solutions/whitepapers",
      function () {
        return require("private-next-pages/recruitment-solutions/whitepapers/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruitment-solutions/whitepapers"])
      });
    }
  